import React, { useState, useRef } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
} from "@mantine/core";
import classes from "./add.module.css";
import { RowDataGPU } from "./types";

interface AddModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (newData: RowDataGPU) => void;
}

const AddGPUModal: React.FC<AddModalProps> = ({
  isOpen,
  onClose,
  onAdd,
}) => {
  const [newData, setNewData] = useState<RowDataGPU>({
    id: "",
    model: "",
    show: false,
    action: "Edit", 
    numberOfGames: 0,
    numberOfRegisteredGames: 0,
    createdAt: "",
    updatedAt: "",
  });
  const imageDropzoneRef = useRef<() => void>(null);

  const handleAddData = () => {
    // Check if any required fields are empty
    if (!newData.model) {
      alert("Please fill in all the required fields");
      return;
    }

    onAdd(newData);

    // Clear inputs and reset state
    setNewData({
      id: "",
      model: "",
      show: false,
      action: "Edit",
      numberOfGames: 0,
    numberOfRegisteredGames: 0,
      createdAt: "",
        updatedAt: "",
    });

    onClose();
  };

  const handleClose = () => {
    // Clear inputs and reset state
    setNewData({
      id: "",
      model: "",
      show: false,
      action: "Edit",
      createdAt: "",
    updatedAt: "",
    numberOfGames: 0,
    numberOfRegisteredGames: 0,
    });

    // Call the onClose function
    onClose();
  };

  return (
    <Modal
      style={{ zIndex: "100" }}
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          New GPU Model
        </div>
      }
      opened={isOpen}
      onClose={handleClose}
    >
      <TextInput
        label="GPU model"
        placeholder="Input model"
        mb="sm"
        maxLength={255}
        value={newData.model}
        onChange={(event) =>
            setNewData({ ...newData, model: event.currentTarget.value })
        }
      />


      <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonBack}>
          Back
        </Button>
        <Button onClick={handleAddData} className={classes.buttonSubmit}>
          Submit
        </Button>
      </Group>
    </Modal>
  );
};

export default AddGPUModal;
